<template>
  <div>
    <v-select
      :items="profileOptions"
      :disabled="disabled"
      :label="
        $t('components.selectors.profileSelector.selectTelematicsProfile')
      "
      v-model="selectedProfileUUID"
      item-text="name"
      item-value="uuid"
      color="primary"
      clearable
      no-filter
    >
      <template v-slot:item="{ item }">
        <span>
          {{ item.name }}
          <v-chip
            outlined
            v-if="item.is_models_default && boat_specific"
            class="ml-1"
            >{{
              $t("components.selectors.profileSelector.modelsDefault")
            }}</v-chip
          >
          <v-chip
            outlined
            v-if="!item.is_models_default && boat_specific"
            class="ml-1"
            >{{
              $t("components.selectors.profileSelector.nonstandard")
            }}</v-chip
          >
        </span>
      </template>
      <template v-slot:selection="{ item }">
        <span>
          {{ item.name }}
          <v-chip
            outlined
            v-if="item.is_models_default && boat_specific"
            class="ml-1"
            >{{
              $t("components.selectors.profileSelector.modelsDefault")
            }}</v-chip
          >
          <v-chip
            outlined
            v-if="!item.is_models_default && boat_specific"
            class="ml-1"
            >{{
              $t("components.selectors.profileSelector.nonstandard")
            }}</v-chip
          >
        </span>
      </template>
    </v-select>
    <span v-if="disabled">
      {{
        $t(
          "components.selectors.profileSelector.telematicsProfileCannotBeChangedForRetrofittedBoats"
        )
      }}
    </span>
  </div>
</template>

<script>
import api from "@/utils/api";

export default {
  props: [
    "selected_profile_uuid",
    "selected_brand_uuid",
    "initial_data",
    "sort",
    "boat_specific",
    "disabled",
    "model_selected_profile_uuid",
  ],
  data: () => ({
    profileOptions: [],
    profileSearch: "",
    noProfileOption: {},
  }),
  created() {
    this.noProfileOption = {
      name: this.$t("components.selectors.profileSelector.noProfile"),
      //NOTE: UUID must be defined, otherwise v-select will not work, should not be applied in API call
      uuid: 1,
      is_special: true,
      is_models_default: this.model_selected_profile_uuid == null,
    };
    this.loadOptions(true);
  },

  methods: {
    loadOptions(initialLoad = false) {
      api.profilesAutocomplete(this.selected_brand_uuid).then((resp) => {
        this.profileOptions = resp.data.map((item, index) => {
          if (
            this.initial_data != null &&
            this.initial_data.uuid != null &&
            item.uuid === this.initial_data.uuid
          ) {
            return {
              ...item,
              index: -1,
              is_models_default: item.uuid == this.model_selected_profile_uuid,
            };
          }
          return {
            ...item,
            index: index,
            is_models_default: item.uuid == this.model_selected_profile_uuid,
          };
        });

        if (this.sort) {
          this.profileOptions.sort((a, b) => {
            return a.index - b.index;
          });
        }

        if (this.noProfileOption.is_models_default && this.boat_specific) {
          this.profileOptions.unshift(this.noProfileOption);
        } else {
          this.profileOptions.push(this.noProfileOption);
        }

        if (this.initial_data && initialLoad) {
          const profileIndex = this.profileOptions.findIndex(
            (item) => item.uuid === this.initial_data.uuid
          );
          if (profileIndex === -1) {
            this.profileOptions.push(this.initial_data);
          }

          this.selectedProfileUUID = this.initial_data.uuid;
        }
      });
    },
  },
  computed: {
    selectedProfileUUID: {
      get: function () {
        if (this.selected_profile_uuid == null) {
          return this.noProfileOption.uuid;
        }
        return this.selected_profile_uuid;
      },
      set: function (value) {
        //NOTE: UUID must be defined, otherwise v-select will not work. UUID with value 1 is a workaround
        if (value == null || value == 1) {
          this.$emit("update:selected_profile_uuid", null);
        } else {
          this.$emit("update:selected_profile_uuid", value);
        }
      },
    },
  },
};
</script>
